module.exports = __webpack_public_path__ + "static/media/CEA_TARIFS_01.01.2024.b59e2ba8.pdf";